<template>
  <div 
    class="base-element-text"
    :style="{
      top: elementInfo.top + 'px',
      left: elementInfo.left + 'px',
      width: elementInfo.width + 'px',
      height: elementInfo.height + 'px',
    }"
  >
    <div
      class="rotate-wrapper"
      :style="{ transform: `rotate(${elementInfo.rotate}deg)` }"
    >
      <div class="element-position" v-if="(elementInfo.outline && elementInfo.outlineShow) || shadowStyles">
        <div 
          class="element-content"
          :class="elementInfo.orderType"
          :style="{
            width: elementInfo.vertical ? 'auto' : elementInfo.width + 'px',
            height: elementInfo.vertical ? elementInfo.height + 'px' : 'auto',
            opacity: elementInfo.opacity,
            textStroke:`${elementInfo.outline&&elementInfo.outlineShow?elementInfo.outline.width:0}px ${elementInfo.outline&&elementInfo.outline.color}`,
            textShadow: shadowStyles,
            lineHeight: elementInfo.lineHeight || 1.5,
            letterSpacing: (elementInfo.wordSpace || 0) + 'px',
            color: elementInfo.defaultColor,
            fontFamily: elementInfo.defaultFontName,
            fontSize: elementInfo.defaultFontSize,
            transform: flipStyle,
            textAlign: elementInfo.textAlign,
            writingMode:elementInfo.vertical?'vertical-rl' : 'horizontal-tb',
            textFillColor: elementInfo.fillType === 'pure' && elementInfo.fillShow? elementInfo.fill : elementInfo.fillType === 'gradient' || elementInfo.fillType === 'swatches' && elementInfo.fillShow?'transparent':'unset',
          }"
        >
                <div 
        class="text ProseMirror-static" 
        v-html="elementInfo.content"
        
        ></div>
        </div>
      </div>
      <div 
        class="element-content"
        :class="elementInfo.orderType"
        :style="{
          width: elementInfo.vertical ? 'auto' : elementInfo.width + 'px',
          height: elementInfo.vertical ? elementInfo.height + 'px' : 'auto',
          opacity: elementInfo.opacity,
          lineHeight: elementInfo.lineHeight || 1.5,
          letterSpacing: (elementInfo.wordSpace || 0) + 'px',
          color: elementInfo.defaultColor,
          fontFamily: elementInfo.defaultFontName,
          fontSize:elementInfo.defaultFontSize,
          transform: flipStyle,
          textAlign: elementInfo.textAlign,
          writingMode:elementInfo.vertical?'vertical-rl' : 'horizontal-tb',
              textFillColor: elementInfo.fillType === 'pure' && elementInfo.fillShow? elementInfo.fill : elementInfo.fillType === 'gradient' && elementInfo.fillShow || elementInfo.fillType === 'swatches' && elementInfo.fillShow?'transparent':'unset',
              backgroundImage: (elementInfo.fillType === 'gradient' && elementInfo.fillShow && elementInfo.gradients) ? getGradientString(elementInfo.gradients && elementInfo.gradients.r) : elementInfo.gradient,
          
        }"
      >
        <div 
        class="text ProseMirror-static" 
        v-html="elementInfo.content"
        
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { PPTTextElement } from '@/types/slides'
import useElementShadow from '@/views/components/element/hooks/useElementShadows'
import useElementFlip from '../hooks/useElementFlip'

export default defineComponent({
  name: 'base-element-text',
  components: {},
  props: {
    elementInfo: {
      type: Object as PropType<PPTTextElement>,
      required: true,
    },
  },
  setup(props) {
    const shadow = computed(() => props.elementInfo.shadow)
    const { shadowStyles } = useElementShadow(shadow)
    const flipH = computed(() => props.elementInfo.flipH)
    const flipV = computed(() => props.elementInfo.flipV)
    const { flipStyle } = useElementFlip(flipH, flipV)
    const orderedStops = computed(() => {
      
      return [...props.elementInfo.gradients.g].sort((a, b) => a.p - b.p)
    })
    const getGradientString = (angle:any) => {
      const color = orderedStops.value
        .map((stop) => `${stop.c} ${stop.p}%`)
        .join(",")
      return `linear-gradient(${angle}deg, ${color})`
    }
    return {
      shadowStyles,flipStyle,getGradientString
    }
  },
})
</script>

<style lang="scss" scoped>
.base-element-text {
  position: absolute;
}
.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-position {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.element-content {
  position: relative;
  word-break: break-word;
  padding: 5px 8px;
  line-height: 1.5;
  background-clip: text;
  -webkit-background-clip: text;
  -o-background-clip: text;
  -moz-background-clip: text;
  .text {
    position: initial;
  }
}
</style>
